export default {
  userFocusedEmailInput: 'userFocusedEmailInput',
  userEnteredValidEmail: 'userEnteredValidEmail',
  userFocusedPasswordInput: 'userFocusedPasswordInput',
  userClickedHomepageUsecaseButton: 'userClickedUsecaseButton',
  userClickedHomepageMakeAFlowpageButton: 'userClickedMakeAFlowcodeButton',
  userClickedHomepageLearnMoreAboutProButton: 'userClickedLearnMoreAboutProButton',
  userClickedHomepageLearnMoreAboutTVButton: 'userClickedLearnMoreAboutTVButton',
  userChangedHomepageSlide: 'userChangedHomepageSlide',
  userClickedHomepageMakeAFlowcodeButton: 'userClickedHomepageMakeAFlowcodeButton',
  userClickedHomepageFAQAccordion: 'userClickedHomepageFAQAccordion',
  userClickedProUpsellTopNavBanner: 'userClickedProUpsellTopNavBanner',
  userClickedHomepagePlanCard: 'userClickedHomepagePlanCard',
  userClickedCreateAFlowcodeButton: 'userClickedCreateAFlowcodeButton',
  userClickedExplorePlansButton: 'userClickedExplorePlansButton',
  userClickedUploadALogoButton: 'userClickedUploadALogoButton',
  userClickedAddFileButton: 'userClickedAddFileButton',
  userClickedDownloadCodeButton: 'userClickedDownloadCodeButton',
  userClickedRefreshDesigns: 'userClickedRefreshDesigns',
  userChangedAutoDesignOption: 'userChangedAutoDesignOption',
  userCreatedGalleryCode: 'userCreatedGalleryCode',
  Flowcode_Homepage_Clicked_Generate_Code_Button: 'Flowcode_Homepage_Clicked_Generate_Code_Button',
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Email:
    'Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Email',
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Google:
    'Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Google',
  Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Facebook:
    'Flowcode_Simplified_Desktop_Homepage_Clicked_Sign_Up_With_Facebook',
  Flowcode_Simplified_Desktop_Homepage_Created_Account:
    'Flowcode_Simplified_Desktop_Homepage_Created_Account',
  Flowcode_Simplified_Desktop_Homepage_Created_Code:
    'Flowcode_Simplified_Desktop_Homepage_Created_Code',
  Flowcode_Simplified_Desktop_Homepage_Entered_Destination:
    'Flowcode_Simplified_Desktop_Homepage_Entered_Destination',
  Flowcode_Simplified_Desktop_Homepage_Selected_Destination:
    'Flowcode_Simplified_Desktop_Homepage_Selected_Destination',
  Flowcode_Simplified_Desktop_Homepage_Selected_Pattern:
    'Flowcode_Simplified_Desktop_Homepage_Selected_Pattern',
  Flowcode_Simplified_Desktop_Homepage_Selected_Color:
    'Flowcode_Simplified_Desktop_Homepage_Selected_Color',
  Flowcode_Simplified_Desktop_Homepage_Uploaded_Image:
    'Flowcode_Simplified_Desktop_Homepage_Uploaded_Image',
  Flowcode_Simplified_Desktop_Homepage_Selected_Shape:
    'Flowcode_Simplified_Desktop_Homepage_Selected_Shape',
  Flowcode_Simplified_Desktop_Homepage_Go_To_Step:
    'Flowcode_Simplified_Desktop_Homepage_Go_To_Step',
  Flowcode_Simplified_Desktop_Homepage_Go_Back: 'Flowcode_Simplified_Desktop_Homepage_Go_Back',
  Flowcode_Simplified_Desktop_Homepage_Clicked_Click_Here:
    'Flowcode_Simplified_Desktop_Homepage_Clicked_Click_Here',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Preview_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Preview_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Selected_Destination:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Selected_Destination',
  Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Entered_Destination',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Email:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Email',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Google:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_Up_With_Facebook:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Email:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Google',
  Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Sign_In_With_Facebook',
  Flowcode_Combined_Funnel_Mobile_Homepage_SignedIn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_SignedIn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Account:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Created_Account',
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Code:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Created_Code',
  Flowcode_Combined_Funnel_Mobile_Homepage_Created_Page:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Created_Page',
  Flowcode_Combined_Funnel_Mobile_Homepage__Success_Clicked_View_Flowpage_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_View_Flowpage_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Manage_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Manage_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_Btn',
  Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_My_Flowcode_Btn:
    'Flowcode_Combined_Funnel_Mobile_Homepage_Success_Clicked_Email_My_Flowcode_Btn',
  Revenue_HomepageV1_ScrolledTo_Section: 'Revenue_HomepageV1_ScrolledTo_Section',
  Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert: 'Revenue_HomepageV1_Clicked_FAQTalkWithAnExpert',
  Revenue_HomepageV1_Clicked_FAQVisitHelpcenter: 'Revenue_HomepageV1_Clicked_FAQVisitHelpcenter',
  Flowcode_LoggedOutGenerator_Clicked_TopBannerText:
    'Flowcode_LoggedOutGenerator_Clicked_TopBannerText',
  Flowcode_LoggedOutGenerator_Clicked_LowerBannerText:
    'Flowcode_LoggedOutGenerator_Clicked_LowerBannerText'
}
